/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Strikethrough",
  size: 20
}

const SvgStrikethrough = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M6 13.02h.65c.99 2.14 2.21 3.1 3.76 3.1 1.81 0 2.51-1.19 2.51-2.23 0-1.34-.93-1.86-3.18-2.66-1.69-.59-3.51-1.12-3.51-3.4 0-2.33 1.86-3.74 4.17-3.74 1.04 0 1.73.22 2.32.45l.61-.54h.48v3.59h-.65c-.61-1.71-1.64-2.7-3.09-2.7-1.23 0-2.18.8-2.18 2.14 0 1.26 1 1.75 2.99 2.42 1.69.58 3.5 1.15 3.5 3.46 0 1.84-1.11 4.02-4.2 4.02-1 0-2.01-.24-2.72-.54l-.94.61H6v-3.98z" />
    <path d="M3 10h15v1H3z" />
  </Svg>
)

SvgStrikethrough.defaultProps = defaultProps
export default SvgStrikethrough
